<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content">
      <Home
        v-if="page == 'home'"
        @mtdChangePage="mtdChangePage"
        @mtdBackCampus="mtdBackCampus"
      />
      <MantenimientoView
        v-if="page == 'mantenimiento'"
        @mtdChangePage="mtdChangePage"
      />
      <HorarioView v-if="page == 'horario'" @mtdChangePage="mtdChangePage" />
    </div>
    <div class="footer">
      <Footer @mtdChangePage="mtdChangePage" :pageView="page" />
    </div>
  </div>
</template>
    
        
<script>
import Nav from "../../components/Asistencial/Nav.vue";
import Home from "../../components/Enfermeria/Home.vue";
import Footer from "../../components/Enfermeria/Footer.vue";
import MantenimientoView from "../../components/Enfermeria/pages/MaintenanceEnfermeria.vue";
import HorarioView from "../../components/Enfermeria/pages/Horario.vue";

export default {
  name: "v-enfermeria",
  components: {
    Nav,
    Home,
    Footer,
    MantenimientoView,
    HorarioView,
  },
  data() {
    return {
      page: "home",
      rol_name: null,
    };
  },
  props: {
    rolname: String,
    dataRoles: Array,
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdChangePage: function (page) {
      this.page = page;
    },
  },
};
</script>
    